import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';

/** 削除対象デバイスリスト */
type DevicesToDelete = {
  /** シリアル番号 */
  serialNo: string;

  /** テナント名 */
  tenantName: string;
}[];

/** ダイアログオプション */
export type DeviceListDeleteDialogOption = {
  /** メッセージ */
  message: string;

  /** タイトル */
  title?: string;

  /** 削除対象のデバイスデータ */
  devices: DevicesToDelete;
};

@Component({
  selector: 'app-device-list-delete-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
  ],
  templateUrl: './device-list-delete-dialog.component.html',
  styleUrl: './device-list-delete-dialog.component.scss',
})
export class DeviceListDeleteDialogComponent {
  /** タイトル */
  public title = 'Confirm';

  /** メッセージ */
  public message = '';

  public devicesToDelete: DevicesToDelete = [];

  public displayedColumns: string[] = ['serialNo', 'tenantName'];

  constructor(
    @Inject(MAT_DIALOG_DATA) data: DeviceListDeleteDialogOption,
    private dialogRef: MatDialogRef<DeviceListDeleteDialogComponent>
  ) {
    this.title = data.title || this.title;
    this.message = data.message;
    this.devicesToDelete = data.devices;
  }

  /**
   * 操作を実行する
   */
  public doOperation() {
    this.dialogRef.close(true);
  }
}
